module.exports = __webpack_public_path__ + "static/media/signage-indoor-img5.50510e78.jpg";